import { createClient } from '@supabase/supabase-js';

// Hardcoded as fallback — .env spaces/quotes bug caused undefined values
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://pngfdxqxorbxhuaezgij.supabase.co';
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBuZ2ZkeHF4b3JieGh1YWV6Z2lqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI3MDUyNDEsImV4cCI6MjA4ODI4MTI0MX0.Flcj3jnG4uZmNzZ_hoqBfFFiiQ-Brp5wdc1-u24gCZc';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);